<template>
    <div class="wrapper">
        <ul class="infoTab">
            <li :class="show === 'store' ? 'active':''"><a @click="changeCategory('store')" href="#">店舗</a></li>
            <li :class="show === 'news' ? 'active':''"><a @click="changeCategory('news')" href="#">ニュース</a></li>
        </ul>
        <ul class="contentsList" v-if="show === 'store'">
            <li>
                <div class="contentsWrap">
                    <div class="eyecatch">
                        <img src="">
                    </div>
                    <div class="detail">
                        <div class="location">
                            <ol>
                                <li><a href="">島名</a></li>
                                <li><a href="">エリア名</a></li>
                            </ol>
                        </div>
                        <div class="name">＠店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店…</div>
                        <div class="categories">
                            <div class="category">カテゴリー名</div>
                            <div class="icon star">4.4</div>
                            <div class="icon heart">122</div>
                        </div>
                    </div>
                    <div class="favoriteIcon"></div>
                </div>
            </li>
            <li>
                <div class="contentsWrap">
                    <div class="eyecatch">
                        <img src="">
                    </div>
                    <div class="detail">
                        <div class="location">
                            <ol>
                                <li><a href="">島名</a></li>
                                <li><a href="">エリア名</a></li>
                            </ol>
                        </div>
                        <div class="name">＠店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店…</div>
                        <div class="categories">
                            <div class="category">カテゴリー名</div>
                            <div class="icon star">4.4</div>
                            <div class="icon heart">122</div>
                        </div>
                    </div>
                    <div class="favoriteIcon"></div>
                </div>
            </li>
            <li>
                <div class="contentsWrap">
                    <div class="eyecatch">
                        <img src="">
                    </div>
                    <div class="detail">
                        <div class="location">
                            <ol>
                                <li><a href="">島名</a></li>
                                <li><a href="">エリア名</a></li>
                            </ol>
                        </div>
                        <div class="name">＠店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店…</div>
                        <div class="categories">
                            <div class="category">カテゴリー名</div>
                            <div class="icon star">4.4</div>
                            <div class="icon heart">122</div>
                        </div>
                    </div>
                    <div class="favoriteIcon"></div>
                </div>
            </li>
            <li>
                <div class="contentsWrap">
                    <div class="eyecatch">
                        <img src="">
                    </div>
                    <div class="detail">
                        <div class="location">
                            <ol>
                                <li><a href="">島名</a></li>
                                <li><a href="">エリア名</a></li>
                            </ol>
                        </div>
                        <div class="name">＠店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店…</div>
                        <div class="categories">
                            <div class="category">カテゴリー名</div>
                            <div class="icon star">4.4</div>
                            <div class="icon heart">122</div>
                        </div>
                    </div>
                    <div class="favoriteIcon"></div>
                </div>
            </li>
        </ul>
        <ul class="contentsList" v-if="show === 'news'">
            <li>
                <div class="contentsWrap">
                    <div class="eyecatch">
                        <img src="">
                    </div>
                    <div class="detail">
                        <div class="location">
                            <ol>
                                <li><a href="">島名</a></li>
                                <li><a href="">エリア名</a></li>
                            </ol>
                        </div>
                        <div class="name">＠店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店…</div>
                        <div class="categories">
                            <div class="category">カテゴリー名</div>
                            <div class="icon heart">122</div>
                        </div>
                    </div>
                    <div class="favoriteIcon"></div>
                </div>
            </li>
            <li>
                <div class="contentsWrap">
                    <div class="eyecatch">
                        <img src="">
                    </div>
                    <div class="detail">
                        <div class="location">
                            <ol>
                                <li><a href="">島名</a></li>
                                <li><a href="">エリア名</a></li>
                            </ol>
                        </div>
                        <div class="name">＠店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店…</div>
                        <div class="categories">
                            <div class="category">カテゴリー名</div>
                            <div class="icon heart">122</div>
                        </div>
                    </div>
                    <div class="favoriteIcon"></div>
                </div>
            </li>
            <li>
                <div class="contentsWrap">
                    <div class="eyecatch">
                        <img src="">
                    </div>
                    <div class="detail">
                        <div class="location">
                            <ol>
                                <li><a href="">島名</a></li>
                                <li><a href="">エリア名</a></li>
                            </ol>
                        </div>
                        <div class="name">＠店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店…</div>
                        <div class="categories">
                            <div class="category">カテゴリー名</div>
                            <div class="icon heart">122</div>
                        </div>
                    </div>
                    <div class="favoriteIcon"></div>
                </div>
            </li>
            <li>
                <div class="contentsWrap">
                    <div class="eyecatch">
                        <img src="">
                    </div>
                    <div class="detail">
                        <div class="location">
                            <ol>
                                <li><a href="">島名</a></li>
                                <li><a href="">エリア名</a></li>
                            </ol>
                        </div>
                        <div class="name">＠店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店舗名店…</div>
                        <div class="categories">
                            <div class="category">カテゴリー名</div>
                            <div class="icon heart">122</div>
                        </div>
                    </div>
                    <div class="favoriteIcon"></div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    data() {
        return {
            show: 'store',
        }
    },
    mounted() {
    },
    methods: {
        changeCategory(category) {
            if(category === 'store'){
                this.show = 'store'
            } else {
                this.show = 'news'
            }
        },
    },
    watch: {
        show(val) {
            if (!val) return
        }
    }
}
</script>
